import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Icon, Button, Drawer } from "antd";

import { showMenu, disableCaption } from "../redux/actions/interfaceActions";
import { unsetActiveProfile } from "../../modules/Authorization/redux/actions/ProfileList";
import { resetLogin } from "../../modules/Authorization/redux/actions/RestoreLogin";
import { Link } from "react-router-dom";

import logo from "../images/svg/logo.svg";

import { ProfilePhoto } from "../components/profilePhoto/profilePhoto";
import MainPanel from "../../modules/ControlPanel/components/MainPanel";
import { IMAGE_SERVER } from "../constants/systemUrls";
import "../css/drawer.css";

class Header extends React.PureComponent {
  state = {
    maxStringCount: 20
  };
  showMenu = () => {
    if (this.props.isAuthorized) {
      this.props.showMenu();
    }
  };

  stringFormatter(str) {
    return str.length > this.state.maxStringCount
      ? str.substr(0, this.state.maxStringCount) + "..."
      : str;
  }

  render() {
    const {
      isMenuVisible,
      user,
      activeProfile,
      isAuthorized,
      buttons,
      profiles
    } = this.props;
    const isUserLogged =
      user &&
      (user.name || user.lastname) &&
      // user.patronymic &&
      profiles &&
      profiles.length > 0;
    const notUserLogged = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    let hrefLink = "#";
    return (
      <div
        id="header"
        className={
          (isMenuVisible ? "menuActive" : "") + (isAuthorized ? "" : " noLogin")
        }
      >
        <Drawer
          id="drawerBurger"
          title="Панель управления"
          placement="left"
          closable={false}
          onClose={this.showMenu}
          visible={isMenuVisible}
          style={{
            padding: 0,
            fontSize: 24
          }}
          headerStyle={{
            background: "#00a8ff",
            borderRadius: 0,
            color: "#ffffff",
            borderBottom: "none",
            fontSize: 24
          }}
          bodyStyle={{
            background: "#001529",
            color: "#ffffff",
            overflowY: "auto",
            height: "calc(100vh - 54px)"
          }}
        >
          <MainPanel
            handleClick={() => this.showMenu}
            isBurger={true}
            buttons={buttons}
          />
        </Drawer>
        <div id="headerRow">
          <div
            className="headerRowContainer"
            style={isUserLogged ? null : notUserLogged}
          >
            <div id="headLogoContainer" className="headerCell">
              {activeProfile.profileId && isAuthorized && isUserLogged && (
                <span
                  style={{ textAlign: "left" }}
                  onClick={this.showMenu}
                  className="logoCell Burger"
                >
                  &equiv;
                </span>
              )}
              <Link
                to={
                  this.props.loginStatus.message === "SUCCESS"
                    ? "/authorization/profiles"
                    : "/"
                }
              >
                <span className="logoCell">
                  <img src={logo} id="mainLogo" alt="Teleportos logo" />
                </span>
              </Link>
            </div>
            {isAuthorized && isUserLogged && (
              <Fragment>
                <div id="headNotifContainer" className="headerCell">
                  <div className="notify">
                    <span className="notifyIcon">
                      <Icon type="bell" />
                    </span>
                    <span className="notifyTxt">Нет уведомлений</span>
                  </div>
                </div>
                <div id="headUserContainer" className="headerCell">
                  <div className="user">
                    <div className="userInfo">
                      <Link to={hrefLink}>
                        {user ? (
                          <span className="userFio">
                            {user.lastname + " " + user.name}
                          </span>
                        ) : (
                          <span className="userFio">Anonymous</span>
                        )}
                        <br />
                        {
                          <React.Fragment>
                            {activeProfile.role && (
                              <div className="userRole">
                                {activeProfile.role}
                              </div>
                            )}
                            {activeProfile.nameLegal && (
                              <div className="nameLegal">
                                {this.stringFormatter(activeProfile.nameLegal)}
                              </div>
                            )}
                          </React.Fragment>
                        }
                      </Link>
                    </div>
                    <div
                      className="userImage"
                      style={{
                        marginRight: 10
                      }}
                    >
                      {user.nameLegal ? (
                        <Link to={hrefLink}>
                          {user.photo ? (
                            <ProfilePhoto
                              {...this.props}
                              url={IMAGE_SERVER + user.photo}
                            />
                          ) : (
                            <ProfilePhoto {...this.props} url={null} />
                          )}
                        </Link>
                      ) : (
                        <Link to={hrefLink}>
                          {user.photo ? (
                            <ProfilePhoto
                              {...this.props}
                              url={IMAGE_SERVER + user.photo}
                            />
                          ) : (
                            <ProfilePhoto {...this.props} url={null} />
                          )}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
            {isAuthorized &&
              (isUserLogged ? null : (
                <Button
                  onClick={() => {
                    this.props.resetLogin();
                    this.props.disableCaption();
                  }}
                  type="link"
                >
                  Выйти
                  <Icon type="logout" />
                </Button>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    isMenuVisible: state.Interface.elements.isMenuVisible,
    isAuthorized: state.Authorization.user.isAuthorized,
    loginStatus: state.Authorization.status.loginStatus,
    activeProfile: state.Authorization.activeProfile,
    buttons: state.Interface.buttons.buttons,
    profiles: state.Authorization.profiles.profiles
  }),
  {
    showMenu,
    unsetActiveProfile,
    resetLogin,
    disableCaption
  }
)(Header);
